export { default } from './SWSectionHeroBannerUpload';
